import Vue from 'vue';
import { formatDateByLocale, getTodayAsString } from '@wl-vue-utils/date-utils';
import { mapFilters } from '@wl-vue-utils/filter-utils';
import { loadAppointment } from "@/api/testride-api";



export default {
  namespaced: true,
  state: {
    pageData: null,
    commonData: null,
    currentLocale: '',
    selectedBrand: '',
    currentCountry: null,
    models: null,
    selectedModel: '',
    selectedAddress: '',
    selectedDate: null,
    initialSelectedDate:null,
    selectedFormattedDate: null,
    initialSelectedFormattedDate:null,
    selectedDealer: null,
    today: null,
    lmpApiUrl: '',
    availableVehicleDisplacement: null,
    appointment: {
      displacementObj: [],
      displacement: null,
      driverLicenseType: null,
      testrideDuration: null,
      dateStr: null,
      slot: null,
      firstname:'',
      lastname: '',
      vehicleId: null
    },
    bookingData: null,
    status: "idle", // idle | loading | success | expired | error
    modelOptions: {
        engizeSize:   null,
        flexibleDate: null,
        rage: [5, 10, 20, 50],
        promo: [],
        preferredHour: null
    },
    filters: {
      selections: []
    },
    appliedFilters:null,
  },
  mutations: {
    SET_TODAY(state, todayStr) {
      state.today = todayStr;
    },
    SET_PAGE_DATA(state, value) { 
      state.pageData = value 
    },
    SET_COMMON_DATA(state, value) { 
      state.commonData = value 
    },
    SET_SELECTED_BRAND(state, value) {
      state.selectedBrand = value
    },
    SET_CURRENT_COUNTRY(state, value) {
      state.currentCountry = value
    },
    SET_MODELS(state, value) {
      state.models = value
    },
    SET_SELECTED_MODEL(state, value) {
      state.selectedModel = value
    },
    SET_SELECTED_ADDRESS(state, value) {
      state.selectedAddress = value
    },
    SET_SELECTED_DATE(state, date) {
      state.selectedDate = date;

      const formatted = date
        ? formatDateByLocale(date, state.currentLocale)
        : null;

      state.selectedFormattedDate = formatted;

      if (state.initialSelectedDate === null) {
        state.initialSelectedDate = date;
      }
      if (state.initialSelectedFormattedDate === null && formatted !== null) {
        state.initialSelectedFormattedDate = formatted;
      }
    },
    SET_FORMATTED_DATE(state, formatted) {
      state.selectedFormattedDate = formatted;
      if (state.initialSelectedFormattedDate === null && formatted !== null) {
        state.initialSelectedFormattedDate = formatted;
      }
    },
    SET_CURRENT_LOCALE(state, locale) {
      const normalized = locale.replace('_', '-');
      state.currentLocale = normalized;
      if (state.selectedDate) {
        const formatted = formatDateByLocale(
          state.selectedDate,
          normalized
        );

        state.selectedFormattedDate = formatted;

        if (state.initialSelectedFormattedDate === null) {
          state.initialSelectedFormattedDate = formatted;
        }
      }
    },
    SET_SELECTED_DEALER(state, value) {
      state.selectedDealer = value
    },
    SET_APPOINTMENT(state,value){
      state.appointment = value
    },
    SET_BOOKING_DATA(state,value){
      state.bookingData = value
    },
    UPDATE_APPOINTMENT(state, { key, value }) {
      Vue.set(state.appointment, key, value)
    },
    CLEAR_APPOINTMENT(state) {
      Object.assign(state.appointment, {
        displacementObj: [],
        displacement: null,
        driverLicenseType: null,
        testrideDuration: null,
        dateStr: null,
        slot: null,
        firstname:'',
        lastname: '',
      });
    },
    SET_LMP_API_URL(state, value) {
      state.lmpApiUrl = value;
    },
    SET_AVAILABLE_VEHICLE_DISPLACEMENT(state, value) {
      state.availableVehicleDisplacement = value;
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
    // UPDATE_FILTERS_SELECTIONS(state, status) {
    //   state.filters.selections.splice(0, state.filters.selections.length, ...status);
    // },
    // APPLY_FILTERS(state) {
    //   state.appliedFilters = mapFilters(state.selectedFilters);
    // },
    UPDATE_FILTERS_SELECTIONS(state, selections) {
      const normalized = Array.isArray(selections) ? selections : [];

      state.filters.selections.splice(
        0,
        state.filters.selections.length,
        ...normalized
      );
    },
    SET_APPLIED_FILTERS(state, filters) {
      state.appliedFilters = filters;
    }
  },
  actions: {
    setPageData({ commit, dispatch }, data) {
        commit('SET_PAGE_DATA', data)
        const component0 = data.main['component-0'];
        if (component0.lmpApiUrl) {
          commit('SET_LMP_API_URL', component0.lmpApiUrl);
        }
        if (data.main['component-0'].models) dispatch('setModels', data.main['component-0'].models)
    },
  
    setOnlyPageData({ commit, dispatch }, data) {
        commit('SET_PAGE_DATA', data)
    },

    setCommonData({ commit, dispatch }, data) {
        commit('SET_COMMON_DATA', data)

        // inizializza i campi “runtime” partendo dal commonData
        if (data.brandName) dispatch('setSelectedBrand', data.brandName)
        if (data.currentCountry) dispatch('setCurrentCountry', data.currentCountry)
        if (data.currentLocale) dispatch('setCurrentLocale', data.currentLocale)

    },

    // azioni singole
    
    setCurrentCountry({ commit }, value) { commit('SET_CURRENT_COUNTRY', value) },
    setCurrentLocale({ commit }, value) { commit('SET_CURRENT_LOCALE', value) },
    setModels({ commit }, value) { commit('SET_MODELS', value) },
    setLocale({ commit }, locale) { commit('SET_CURRENT_LOCALE', locale); },


    setSelectedBrand({ commit }, value) { commit('SET_SELECTED_BRAND', value) },
    setSelectedModel({ commit }, value) { commit('SET_SELECTED_MODEL', value) },
    setSelectedAddress({ commit }, value) { commit('SET_SELECTED_ADDRESS', value) },
    setSelectedDate({ commit }, date) { commit('SET_SELECTED_DATE', date); },
    
    setSelectedDealer({ commit }, value) { commit('SET_SELECTED_DEALER', value) },

    setAppointment({ commit }, value) { commit('SET_APPOINTMENT', value) },

    setBookingData({ commit }, value) { commit('SET_BOOKING_DATA', value) },

    async loadBookingData({ commit, state, dispatch }, token) { 
      commit("SET_STATUS", "loading");
      try{
        const currentLanguage = state.commonData.currentLanguage;
        const currentCountry = state.currentCountry;
        const data =  await loadAppointment(currentCountry, currentLanguage, token);
        commit('SET_BOOKING_DATA', data) ;
        commit('SET_SELECTED_DEALER', data.vehicle.store);
        commit('SET_SELECTED_BRAND', data.vehicle.brand);
        commit('SET_SELECTED_MODEL', data.vehicle.model);
        commit('SET_SELECTED_DATE', new Date(data.appointmentDate));
        dispatch('refreshFormattedDate');
        dispatch('updateAppointment',{
          key: 'displacement', value: data.vehicle.displacement
        });
        dispatch('updateAppointment',{
          key: 'driverLicenseType', value: data.vehicle.driverLicenseType
        });
        dispatch('updateAppointment',{
        key: 'testrideDuration', value: data.vehicle.testrideDuration
        });
        dispatch('updateAppointment',{
          key: 'firstname', value: data.firstName
        });
        dispatch('updateAppointment',{
          key: 'lastname', value: data.lastName
        });
        commit("SET_STATUS", "success");
        return data;
      } catch(err){
        const status = err.message.match(/\d+/)[0] || null;

        if (status === "410") {
          commit("SET_STATUS", "expired"); // evento scaduto
        } else {
          commit("SET_STATUS", "error");
        }
      }
    },

    updateAvailableVehicleDisplacement({ commit }, value) {
      commit('SET_AVAILABLE_VEHICLE_DISPLACEMENT', value);
    },
    updateAppointment({ commit }, data) {
      commit('UPDATE_APPOINTMENT', data)
    },

    clearAppointment({ commit }, data) {
      commit('CLEAR_APPOINTMENT', data)
    },

    refreshFormattedDate({ state, commit }) {
      if (state.selectedDate) {
        const formatted = formatDateByLocale(
          state.selectedDate,
          state.currentLocale
        );
        commit('SET_FORMATTED_DATE', formatted);
      }
    },
    initToday({ commit }) {
      const todayStr = getTodayAsString();
      commit('SET_TODAY', todayStr);
    },
    refreshToday({ commit }) {
      // per ricalcolarla manualmente (es. cambio giorno)
      const todayStr = getTodayAsString();
      commit('SET_TODAY', todayStr);
    },
    // updateFilterSelections: function({commit}, value) {
    //   commit('UPDATE_FILTERS_SELECTIONS', value );
    // },
    // applyFilters({ state, commit }) {
    //   const mapped = mapFilters(state.filters.selections);
    //   commit("SET_APPLIED_FILTERS", mapped);
    // }
    updateFilterSelections({ commit }, value) {
      commit("UPDATE_FILTERS_SELECTIONS", value);
    },

    applyFilters({ state, commit }) {
      const mapped = mapFilters(state.filters.selections);
      commit("SET_APPLIED_FILTERS", mapped);
    }

    
  },
  getters: {
    // accesso diretto ai dati “runtime”
    currentCountry: state => state.currentCountry,
    models: state => state.models,
    selectedBrand: state => state.selectedBrand,
    selectedAddress: state => state.selectedAddress,
    selectedModel: state => state.selectedModel,
    selectedDate: state => state.selectedDate,
    initialSelectedDate: state => state.initialSelectedDate,
    currentLocale: state => state.currentLocale,
    selectedFormattedDate: state => state.selectedFormattedDate,
    initialSelectedFormattedDate: state => state.initialSelectedFormattedDate,
    selectedDealer: state => state.selectedDealer,
    appointment: state => state.appointment,
    availableVehicleDisplacement: state => state.availableVehicleDisplacement,
    bookingData: state => state.bookingData,
    status: state => state.status,
    
    // pageData completa
    pageData: state => state.pageData,
    commonData: state => state.commonData,

    today: state => state.today,
    lmpApiUrl: state => state.lmpApiUrl,
    formattedDateComputed: state => {
      if (!state.selectedDate) return '';
      return formatDateByLocale(state.selectedDate, state.currentLocale);
    },
    modelOptions: state => state.modelOptions,
    selectedFilters: state => state.filters.selections,
    appliedFilters: state => state.appliedFilters
  }
}
